export const LAST_USED_ADDRESS_KEY = "lastUsedAddress";
export const LAST_USED_GUEST_EMAIL_KEY = "lastUsedGuestEmail";
export const LAST_USED_GUEST_PHONE_KEY = "lastUsedGuestPhone";
export const APPLIED_PROMOTION_CODE_KEY = "appliedPromotionCode";

export type StoredPromotionCode = {
  promotionCode: string;
  confirmationMessage?: string;
};

export const getStoredPromotionCode = (): StoredPromotionCode | null => {
  const storedPromotionCode = localStorage.getItem(APPLIED_PROMOTION_CODE_KEY);
  if (!storedPromotionCode) {
    return null;
  }

  try {
    const parsedPromotionCode = JSON.parse(
      storedPromotionCode,
    ) as StoredPromotionCode | null;

    if (!parsedPromotionCode?.promotionCode) {
      return null;
    }

    return {
      promotionCode: parsedPromotionCode.promotionCode,
      confirmationMessage: parsedPromotionCode.confirmationMessage || undefined,
    };
  } catch (error) {
    console.error("Error reading stored promotion code:", error);
    return null;
  }
};

export const storePromotionCode = (promotionCode: StoredPromotionCode) => {
  localStorage.setItem(
    APPLIED_PROMOTION_CODE_KEY,
    JSON.stringify(promotionCode),
  );
};

export const clearStoredPromotionCode = () => {
  localStorage.removeItem(APPLIED_PROMOTION_CODE_KEY);
};
